import React, { useCallback, useState } from 'react';
import { Table, Space, Button, Popconfirm } from 'antd';
import { TableWrapper } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import { ColumnsType } from 'antd/lib/table/interface';
import { FileExcelOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';

interface FormItemProps {
  salesList: any[] | undefined;  
  hiddenColumns: string[];  
  actPage: string;
  detailCode: string;
  year: string;
  onCellClick: (month, value) => void;
}

const SALESTable = ({salesList, hiddenColumns, actPage, detailCode, year, onCellClick}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const columns: ColumnsType<any> = [
    {
      title: '매출',
      dataIndex: 'group_step_name',
      key: 'group_step_name',
      width: '100px',
      align: 'center',
    },  
    {
      title: '구분',
      dataIndex: 'group_type',
      key: 'group_type',
      width: '100px',
      align: 'center',
      ellipsis: true,
      sorter: (a, b) => a.group_type.localeCompare(b.group_type),
    },   
    {
      title: '주제',
      dataIndex: 'group_subject',
      key: 'group_subject',
      width: '100px',
      align: 'center',
      ellipsis: true,
      sorter: (a, b) => a.group_subject.localeCompare(b.group_subject),
    },        
    {
      title: '기업',
      dataIndex: 'group_company',
      key: 'group_company',
      width: '120px',
      align: 'center',
      ellipsis: true,
      sorter: (a, b) => a.group_company.localeCompare(b.group_company),
    },            
    {
      title: '1월',
      dataIndex: 'month_01',
      key: 'month_01',
      width: 'auto',
      align: 'right',      
      render: (price, record) => {
        return (
          (price && price > 0)?<a onClick={()=> onCellClick('01', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }         
    },       
    {
      title: '2월',
      dataIndex: 'month_02',
      key: 'month_02',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('02', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '3월',
      dataIndex: 'month_03',
      key: 'month_03',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('03', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '4월',
      dataIndex: 'month_04',
      key: 'month_04',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('04', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '5월',
      dataIndex: 'month_05',
      key: 'month_05',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('05', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '6월',
      dataIndex: 'month_06',
      key: 'month_06',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('06', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '7월',
      dataIndex: 'month_07',
      key: 'month_07',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('07', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '8월',
      dataIndex: 'month_08',
      key: 'month_08',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)?<a onClick={()=> onCellClick('08', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '9월',
      dataIndex: 'month_09',
      key: 'month_09',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('09', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '10월',
      dataIndex: 'month_10',
      key: 'month_10',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('10', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '11월',
      dataIndex: 'month_11',
      key: 'month_11',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('11', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '12월',
      dataIndex: 'month_12',
      key: 'month_12',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('12', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '누계',
      dataIndex: 'month_sum',
      key: 'month_sum',
      width: '100px',
      align: 'right',    
      sorter: (a, b) => a.month_sum - b.month_sum, 
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('ALL', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    },    
    {
      title: '누계',
      dataIndex: 'month_sum',
      key: 'month_sum1',
      width: '100px',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('ALL', record.group_id)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    },                                                   
  ];

  /* ======================================================
  * events
  * ====================================================== */ 
  const onExcelDownload = () => {
    if (!!salesList) {
      const header: string[] = [];
      const datas: any[] = [];
  
      header.push('매출');
      header.push('구분');
      header.push('주제');
      header.push('기업');
      header.push('1월');
      header.push('2월');
      header.push('3월');
      header.push('4월');
      header.push('5월');
      header.push('6월');
      header.push('7월');
      header.push('8월');
      header.push('9월');
      header.push('10월');
      header.push('11월');
      header.push('12월');
      header.push('누계');
  
      let tot_month = 0;
      let tot_month01 = 0;
      let tot_month02 = 0;
      let tot_month03 = 0;
      let tot_month04 = 0;
      let tot_month05 = 0;
      let tot_month06 = 0;
      let tot_month07 = 0;
      let tot_month08 = 0;
      let tot_month09 = 0;
      let tot_month10 = 0;
      let tot_month11 = 0;
      let tot_month12 = 0;

      salesList.forEach(({group_step_name, group_type, group_subject, group_company, group_step, month_01, month_02, month_03, month_04, month_05, month_06, month_07, month_08, month_09, month_10, month_11, month_12, month_sum }) => {
        if (actPage !== 'sales' || detailCode === 'AB' || group_step !== 'AB') {
          tot_month += month_sum?month_sum:0;
          tot_month01 += month_01?month_01:0;
          tot_month02 += month_02?month_02:0;
          tot_month03 += month_03?month_03:0;
          tot_month04 += month_04?month_04:0;
          tot_month05 += month_05?month_05:0;
          tot_month06 += month_06?month_06:0;
          tot_month07 += month_07?month_07:0;
          tot_month08 += month_08?month_08:0;
          tot_month09 += month_09?month_09:0;
          tot_month10 += month_10?month_10:0;
          tot_month11 += month_11?month_11:0;
          tot_month12 += month_12?month_12:0;
        }

        const newItem = {
          '매출': group_step_name,
          '구분': group_type,
          '주제': group_subject,
          '기업': group_company,
          '1월': month_01,
          '2월': month_02,
          '3월': month_03,
          '4월': month_04,
          '5월': month_05,
          '6월': month_06,
          '7월': month_07,
          '8월': month_08,
          '9월': month_09,
          '10월': month_10,
          '11월': month_11,
          '12월': month_12,
          '누계': month_sum,
        }
        datas.push(newItem);        
      })

      const newItem = {
        '매출': '합계',
        '구분': '합계',
        '주제': '합계',
        '기업': '합계',
        '1월': tot_month01,
        '2월': tot_month02,
        '3월': tot_month03,
        '4월': tot_month04,
        '5월': tot_month05,
        '6월': tot_month06,
        '7월': tot_month07,
        '8월': tot_month08,
        '9월': tot_month09,
        '10월': tot_month10,
        '11월': tot_month11,
        '12월': tot_month12,
        '누계': tot_month,
      }
      datas.push(newItem);      

      const book = XLSX.utils.book_new();
      const nurses = XLSX.utils.json_to_sheet(
        datas, 
        { 
          header : header, 
          skipHeader : false 
        } 
      );
  
      nurses["!cols"] = [
        { wpx : 150, hidden: hiddenColumns.findIndex((col)=>col === 'group_step_name') > -1 } 
      , { wpx : 150, hidden: hiddenColumns.findIndex((col)=>col === 'group_type') > -1 } 
      , { wpx : 150, hidden: hiddenColumns.findIndex((col)=>col === 'group_subject') > -1 }  
      , { wpx : 150, hidden: hiddenColumns.findIndex((col)=>col === 'group_company') > -1 }  
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_01') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_02') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_03') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_04') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_05') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_06') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_07') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_08') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_09') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_10') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_11') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_12') > -1 }
      , { wpx : 100 }
      ]
  
      XLSX.utils.book_append_sheet( book, nurses, "NURSES" );

      let pageName = '';
      switch (actPage) {
        case "sales" : 
          pageName = '매출';
          break;
        case "type" : 
          pageName = '구분';
          break;
        case "subject" : 
          pageName = '주제';
          break;
        case "company" : 
          pageName = '기업';
          break;   
        default:            
          pageName = '신규고객';     
          break;
      }

      XLSX.writeFile( book, 'Management_매출_'+pageName+'_'+year+'.xlsx');       
    }
  }  
  /* ======================================================
  * hooks
  * ====================================================== */
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Space style={{width:'100%', justifyContent:'end', marginTop:'20px'}}>
        <Space>
          <Button icon={<FileExcelOutlined />} onClick={onExcelDownload}>엑셀다운로드</Button>
        </Space>              
      </Space>      
      <TableWrapper isSearch={false} >
        <Table
          tableLayout="fixed"
          dataSource={salesList}
          columns={columns.filter((item) => hiddenColumns.findIndex((col)=>col === item.key) < 0)}
          pagination={false}
          bordered
          style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
          className="columnCenterFixTable clickable"
          showSorterTooltip={false}
          summary={pageData => {
            let tot_month = 0;
            let tot_month01 = 0;
            let tot_month02 = 0;
            let tot_month03 = 0;
            let tot_month04 = 0;
            let tot_month05 = 0;
            let tot_month06 = 0;
            let tot_month07 = 0;
            let tot_month08 = 0;
            let tot_month09 = 0;
            let tot_month10 = 0;
            let tot_month11 = 0;
            let tot_month12 = 0;

            pageData.forEach(({group_step, month_01, month_02, month_03, month_04, month_05, month_06, month_07, month_08, month_09, month_10, month_11, month_12, month_sum }) => {
              if (actPage !== 'sales' || detailCode === 'AB' || group_step !== 'AB') {
                tot_month += month_sum?month_sum:0;
                tot_month01 += month_01?month_01:0;
                tot_month02 += month_02?month_02:0;
                tot_month03 += month_03?month_03:0;
                tot_month04 += month_04?month_04:0;
                tot_month05 += month_05?month_05:0;
                tot_month06 += month_06?month_06:0;
                tot_month07 += month_07?month_07:0;
                tot_month08 += month_08?month_08:0;
                tot_month09 += month_09?month_09:0;
                tot_month10 += month_10?month_10:0;
                tot_month11 += month_11?month_11:0;
                tot_month12 += month_12?month_12:0;
              }
            });

            return (
              <>
                <Table.Summary.Row style={{backgroundColor:'#f7f7f7'}}>
                  <Table.Summary.Cell  index={0} align='center'>합계</Table.Summary.Cell>
                  {(hiddenColumns.findIndex((col)=>col === 'month_01') < 0) && (<Table.Summary.Cell  index={2} align='right'><a onClick={()=> onCellClick('01', '')}>{tot_month01.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_02') < 0) && (<Table.Summary.Cell  index={3} align='right'><a onClick={()=> onCellClick('02', '')}>{tot_month02.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_03') < 0) && (<Table.Summary.Cell  index={4} align='right'><a onClick={()=> onCellClick('03', '')}>{tot_month03.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_04') < 0) && (<Table.Summary.Cell  index={5} align='right'><a onClick={()=> onCellClick('04', '')}>{tot_month04.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_05') < 0) && (<Table.Summary.Cell  index={6} align='right'><a onClick={()=> onCellClick('05', '')}>{tot_month05.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_06') < 0) && (<Table.Summary.Cell  index={7} align='right'><a onClick={()=> onCellClick('06', '')}>{tot_month06.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_07') < 0) && (<Table.Summary.Cell  index={8} align='right'><a onClick={()=> onCellClick('07', '')}>{tot_month07.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_08') < 0) && (<Table.Summary.Cell  index={9} align='right'><a onClick={()=> onCellClick('08', '')}>{tot_month08.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_09') < 0) && (<Table.Summary.Cell  index={10} align='right'><a onClick={()=> onCellClick('09', '')}>{tot_month09.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_10') < 0) && (<Table.Summary.Cell  index={11} align='right'><a onClick={()=> onCellClick('10', '')}>{tot_month10.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_11') < 0) && (<Table.Summary.Cell  index={12} align='right'><a onClick={()=> onCellClick('11', '')}>{tot_month11.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_12') < 0) && (<Table.Summary.Cell  index={13} align='right'><a onClick={()=> onCellClick('12', '')}>{tot_month12.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  <Table.Summary.Cell  index={13} align='right'><a onClick={()=> onCellClick('ALL', '')}>{tot_month.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            );
          }}
        />
      </TableWrapper>  
    </Space>
  );
};

export default SALESTable;
